(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('RouteTypeDetailController', RouteTypeDetailController);

    RouteTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RouteType', 'User'];

    function RouteTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, RouteType, User) {
        var vm = this;

        vm.routeType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:routeTypeUpdate', function(event, result) {
            vm.routeType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
